var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{directives:[{name:"cdn",rawName:"v-cdn:src",value:(_vm.logoSrc),expression:"logoSrc",arg:"src"}],staticClass:"mecenat-logotype",attrs:{"alt":"Mecenat"}})
}
var staticRenderFns = []

export { render, staticRenderFns }